// v-clipboard:copy="text", v-clipboard:success="fn", v-clipboard:error="fn",
// the same API vue3-clipboard had, on navigator.clipboard.writeText.
const bindings = new WeakMap();

function state(el) {
  if (!bindings.has(el)) bindings.set(el, {});
  return bindings.get(el);
}

function onClick(event) {
  const trigger = event.currentTarget;
  const { copy: text, success, error } = state(trigger);
  const copying = navigator.clipboard?.writeText(text) ?? Promise.reject(new Error('Clipboard API unavailable'));
  copying.then(
    () => success?.({ action: 'copy', text, trigger }),
    (reason) => error?.({
      action: 'copy', text, trigger, error: reason,
    }),
  );
}

export default {
  install(app) {
    app.directive('clipboard', {
      mounted(el, binding) {
        state(el)[binding.arg] = binding.value;
        if (binding.arg === 'copy') el.addEventListener('click', onClick);
      },
      updated(el, binding) {
        state(el)[binding.arg] = binding.value;
      },
      unmounted(el, binding) {
        if (binding.arg === 'copy') el.removeEventListener('click', onClick);
        delete state(el)[binding.arg];
      },
    });
  },
};
